// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   dashboard.css  -  every class is prefixed with "dash-"
   Replace the WHOLE old dashboard.css with this file.
   ===================================================================== */

/* ---------- page shell ---------- */
.dash-page {
  background: #fff;
  max-height: 90vh;
  overflow-y: auto;
  padding: 20px;
  font-family: Inter, "Poppins", sans-serif;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.dash-page::-webkit-scrollbar { display: none; }

.dash-page-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 16px 4px;
  font-size: 15px;
  font-weight: 700;
  color: #111;
}
.dash-page-title img { width: 24px; height: 24px; }

.dash-loader {
  margin: 80px auto;
  width: 46px;
  height: 46px;
  border: 5px solid #dbe6f5;
  border-top-color: #2563b0;
  border-radius: 50%;
  animation: dash-spin 0.8s linear infinite;
}
@keyframes dash-spin { to { transform: rotate(360deg); } }

/* ---------- filter bar ---------- */
.dash-filter-bar {
  position: relative;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px 28px;
  padding: 22px 26px;
  margin-bottom: 18px;
  background: linear-gradient(90deg, #0b5cab 0%, #073c80 55%, #04295f 100%);
}
.dash-filter-group { display: flex; align-items: center; gap: 10px; }
.dash-filter-label {
  margin: 0;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* 2/11 */
.dash-filter-bar--center {
  justify-content: space-around;
}

/* ---------- stat cards ---------- */
.dash-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 18px;
}

.dash-card {
  --c: #2563b0;
  --bg: #eef3fa;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  min-height: 138px;
  padding: 16px 18px 18px;
  border: 1.5px solid var(--c);
  border-radius: 14px;
  background: var(--bg);
  box-sizing: border-box;
}
.dash-card--tall { flex: 1 1; min-height: 150px; }

.dash-card--blue   { --c: #2563b0; --bg: #eef3fa; }
.dash-card--purple { --c: #8e3fa8; --bg: #f6f0fa; }
.dash-card--orange { --c: #e07a1a; --bg: #fdf7ee; }
.dash-card--green  { --c: #22a05a; --bg: #eaf6ee; }
.dash-card--pink   { --c: #c23a7c; --bg: #fbeaf1; }
.dash-card--indigo { --c: #2b3a8f; --bg: #e8ebf9; }
.dash-card--teal   { --c: #1a9e86; --bg: #e8faf8; }
.dash-card--red    { --c: #c4243a; --bg: #fbe9eb; }

.dash-card__icon img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 50%;
  display: block;
}
.dash-card__arrow {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--c);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dash-card__arrow:hover { transform: scale(1.1); }
.dash-card__arrow:focus-visible { outline: 2px solid var(--c); outline-offset: 2px; border-radius: 50%; }

.dash-card__body { min-width: 0; }
.dash-card__title {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 500;
  color: #3f4344;
  line-height: 1.3;
}
.dash-card__value {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--c);
  white-space: nowrap;
}
.dash-card__bar {
  height: 4px;
  border-radius: 4px;
  background: #c9cdd2;
  overflow: hidden;
}
.dash-card__bar span {
  display: block;
  width: 75%;
  height: 100%;
  border-radius: 4px;
  background: var(--c);
}

/* ---------- chart row ---------- */
.dash-chart-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(250px, 0.9fr) minmax(220px, 0.65fr);
  gap: 14px;
  margin-bottom: 18px;
  align-items: stretch;
}
.dash-chart-grid--budget {
  grid-template-columns: minmax(0, 1.8fr) minmax(280px, 1fr);
}

.dash-chart-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 340px;
  padding: 20px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  overflow: hidden;
}
.dash-chart-title { margin: 0 0 12px; font-size: 15px; font-weight: 700; color: #111; }

.dash-spend { display: flex; align-items: center; gap: 10px; min-width: 0; }
.dash-spend__summary { flex: 0 0 30%; min-width: 125px; max-width: 180px; }
.dash-spend__amount { margin: 0; font-size: 34px; line-height: 1.1; white-space: nowrap; }
.dash-spend__row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
.dash-spend__label { margin: 0; font-size: 13px; line-height: 1.3; color: darkgray; }
.dash-spend__delta { margin: 0; font-size: 13px; font-weight: 700; color: #01b574; white-space: nowrap; }
.dash-spend__status { margin: 8px 0 0; font-size: 15px; font-weight: 700; color: #01b574; }
.dash-spend__chart { flex: 1 1 70%; min-width: 0; overflow: hidden; }

.dash-taxes-chart { display: flex; align-items: center; justify-content: center; flex: 1 1; }
.dash-empty-chart { padding: 40px 0; text-align: center; color: #999; }

.dash-side-cards { display: flex; flex-direction: column; gap: 14px; min-width: 0; }

/* ---------- bottom panels (Vendor Bills / Head Details) ---------- */
.dash-bottom-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr);
  gap: 14px;
}
.dash-panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height:auto;
  padding: 18px 20px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  overflow: hidden;
}
.dash-panel-title { margin: 0 0 14px; font-size: 14px; font-weight: 700; color: #111; }
.dash-panel-scroll { flex: 1 1 auto; min-height: 0; overflow: auto; }

.dash-mini-table { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 12px; }
.dash-mini-table thead th {
  padding: 9px 8px;
  background: #2f78dc;
  color: #fff;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  border-right: 1px solid rgba(255, 255, 255, 0.45);
}
.dash-mini-table thead th:last-child { border-right: none; }
.dash-mini-table tbody td {
  padding: 9px 8px;
  text-align: center;
  color: #333;
  border-bottom: 1px solid #eef1f6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dash-mini-table .dash-mini-empty {
  padding: 16px;
  background: #e6f2fb;
  color: #333;
  font-size: 12px;
}
.dash-status { display: flex; align-items: center; gap: 6px; min-width: 0; }
.dash-status img { width: 16px; height: 16px; flex-shrink: 0; object-fit: contain; }
.dash-mini-bar { height: 6px; background: #e3e7ee; border-radius: 6px; overflow: hidden; }
.dash-mini-bar__fill { height: 100%; width: 50%; background: #2f78dc; }

/* ---------- drill-down table page (grey shell + white card) ----------
   measured from the reference screenshot:
   shell padding 13/13/15/14 | header 36px, gap 12 | card padding 16/19
   table head 41px, rows 43px | footer text 12px bold             */
.dash-table-page {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  padding: 13px 13px 15px 14px;
  background: #edf0f5;
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
  font-family: Arial, Helvetica, sans-serif;
margin:25px;
}
.dash-table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  height: 37px;
  margin-bottom: 12px;
}
.dash-table-head__left { display: flex; align-items: center; gap: 14px; flex-shrink: 0; }

.dash-back-btn {
  width: 36px;
  height: 37px;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dash-back-btn__icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: #0b4f99;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dash-back-btn:focus-visible { outline: 2px solid #2684ff; outline-offset: 2px; }

.dash-table-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: #000;
  white-space: nowrap;
}

/*2/11*/

.dash-search {
  position: relative;
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.dash-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  padding: 0;                    
  background: transparent;
  border-radius: 0;
  object-fit: contain;
  pointer-events: none;
}

.dash-search-input {
  width: 222px;
  height: 34px;
  padding: 0 12px 0 38px;
  border: 1px solid #dfe6ee;
  border-radius: 5px;  
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  font-family: inherit;
  font-size: 12px;
  color: #111;
  outline: none;
  box-sizing: border-box;
}

.dash-search-input::placeholder { color: #777; }

.dash-search-input:focus {
  border-color: #2684ff;
  box-shadow: 0 0 0 1px #2684ff;
}
.dash-table-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 16px 19px ;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.dash-table-scroll {
  flex: 0 1 auto;
  min-height: 0;
  overflow: auto;
  border-radius: 4px;
  position: relative;
}

.dash-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dash-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 41px;
  padding: 0 12px;
  background: #2f7bda;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  border-right: 1px solid #8db8ee;
}
.dash-table thead th:last-child { border-right: none; }
.dash-table thead th:first-child { width: 60px; }
.dash-table tbody td {
  height: 43px;
  padding: 0 12px;
  background: #e4f1fb;
  color: #000;
  text-align: center;
  vertical-align: middle;
  border-right: 1px solid #f3f9fe;
  border-bottom: 1px solid #cfe3f6;
}
.dash-table tbody td:last-child { border-right: none; }
.dash-table tbody tr:last-child td { border-bottom: none; }
.dash-table tbody tr:nth-child(even) td { background: #edf6fd; }
.dash-table tbody tr:hover td { background: #d9ebfa; }
.dash-table .dash-cell-link { color: blue; }
.dash-table .dash-cell-amount { color: #2f78dc; font-weight: 700; }
.dash-table .dash-link { color: #2f78dc; font-weight: 700; cursor: pointer; text-decoration: underline; }

.dash-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 43px;
  background: #e4f1fb;
  color: #000;
  font-size: 12px;
}

.dash-view-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5);
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

/* ---------- pagination (table pages) ---------- */
.dash-pagination {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 0 20px;
}
/*2/11*/
.dash-pagination-info { font-size: 12px;  line-height: 14px; color: #000; white-space: nowrap; }
.dash-pagination-controls { display: flex; align-items: center; gap: 22px; white-space: nowrap; }
.dash-page-numbers { display: flex; align-items: center; gap: 14px; }
.dash-pagination-controls button {
  padding: 0;
  border: none;
  background: transparent;
  color: #444;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  cursor: pointer;
}
.dash-pagination-controls .dash-nav-btn { color: #555; }
.dash-pagination-controls button:disabled { color: #b3b3b3; cursor: not-allowed; }
.dash-page-numbers button.is-active { color: #2ea4e7; text-decoration: underline; }
/* small pager inside the dashboard panels */
.dash-pagination--end { justify-content: flex-end; padding: 8px 0 0; }

/* ---------- photo viewer ---------- */
.dash-photo-page { height: 89vh; padding: 20px 24px; background: #fff; overflow-x: hidden; overflow-y: auto; }
.dash-photo-title { margin-bottom: 24px; font-size: 20px; font-weight: 700; text-align: center; }
.dash-photo-lightbox {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.85);
}

/* ---------- responsive ---------- */
@media (max-width: 1200px) {
  .dash-card-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .dash-chart-grid,
  .dash-chart-grid--budget,
  .dash-bottom-grid { grid-template-columns: minmax(0, 1fr); }
}
@media (max-width: 640px) {
  .dash-card-grid { grid-template-columns: minmax(0, 1fr); }
  .dash-filter-group { width: 100%; justify-content: space-between; }
  .dash-spend { flex-direction: column; align-items: flex-start; }
  .dash-spend__summary { max-width: none; }
  .dash-search-input { width: 170px; }
}


/* Table outer border */
.dash-table-scroll {
  flex: 0 1 auto;
  min-height: 0;
  overflow: auto;
  border-radius: 5px;
  position: relative;

  /* Remove gaps between cells */
  padding: 0;
}

/* Main table */
.dash-table {
  width: 100%;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  table-layout: auto;
  font-size: 12px;
}

/* 2/11 */
/* Header */
.dash-table-scroll {
  flex: 0 1 auto;
  min-height: 0;
  overflow: auto; 
  border-radius: 5px;
  position: relative;
  padding: 0;
}
/* Header first and last cells */
.dash-table thead th:first-child {
  width: 60px;
  border-left: none;
}

.dash-table thead th:last-child {
  border-right: none;
}

/* Table body cells */
.dash-table tbody td {
  height: 43px;
  padding: 0 12px;

  background: #e4f1fb;
  color: #000000;

  text-align: center;
  vertical-align: middle;

  /* Same continuous borders */
  border: 1px solid #cfe3f6;
}

/* Remove outer cell borders */
.dash-table tbody td:first-child {
  border-left: none;
}

.dash-table tbody td:last-child {
  border-right: none;
}

.dash-table tbody tr:last-child td {
  border-bottom: none;
}

/* Alternate rows */
.dash-table tbody tr:nth-child(even) td {
  background: #edf6fd;
}

/* Hover */
.dash-table tbody tr:hover td {
  background: #d9ebfa;
}
/* 2/11 */
.dash-table-card .dash-table-scroll {
  padding: 0 !important;
  border-radius: 5px !important;
}

.dash-table-card .dash-table-scroll .dash-table {
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  border-collapse: separate !important; 
  border-spacing: 0 !important;
}

.dash-table-card .dash-table-scroll .dash-table thead,
.dash-table-card .dash-table-scroll .dash-table thead tr {
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
}

.dash-table-card .dash-table-scroll .dash-table thead th {
  margin: 0 !important;
  background: #2f7bda !important;
  border-top: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-right: 1px solid #ffffff !important;
}

.dash-table-card .dash-table-scroll .dash-table thead th:last-child {
  border-right: 0 !important;
}

.dash-table-card .dash-table-scroll .dash-table tbody td {
  border: 0 !important;
  border-right: 1px solid white !important;
  border-bottom: 1px solid white !important;
}

.dash-table-card .dash-table-scroll .dash-table tbody td:last-child {
  border-right: 0 !important;
}

.dash-table-card .dash-table-scroll .dash-table tbody tr:last-child td {
  border-bottom: 0 !important;
}

.dash-table-card .dash-table-scroll .dash-empty {
  margin: 0 !important;
}

/* 2/11 */
.dash-panel .dash-panel-scroll {
  padding: 0 !important;
  margin: 0 !important;
}

.dash-panel .dash-mini-table {
  margin: 0 !important;
  border: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
}

.dash-panel .dash-mini-table thead,
.dash-panel .dash-mini-table thead tr {
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
}

.dash-panel .dash-mini-table thead th {
  margin: 0 !important;
  background: #2f78dc !important;
  color: #fff !important;
  border: 0 !important;
  border-right: 1px solid white !important;
  box-shadow: none !important;
   border-bottom: 1px solid white !important;
}

.dash-panel .dash-mini-table thead th:last-child {
  border-right: 0 !important;
}

.dash-panel .dash-mini-table tbody td {
  border: 0 !important;
  border-bottom: 1px solid white !important;
}


.dash-panel .dash-panel-title {
  margin: 0 0 8px !important;
}


table tbody tr:nth-child(odd) td {
  background-color: #E5F4FB !important;
}


table tbody tr:nth-child(even) td {
  background-color: #CEE4F1 !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/dashboard.css"],"names":[],"mappings":"AAAA;;;0EAG0E;;AAE1E,qCAAqC;AACrC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,gCAAgC,aAAa,EAAE;;AAE/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA,uBAAuB,WAAW,EAAE,YAAY,EAAE;;AAElD;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA,uBAAuB,KAAK,yBAAyB,EAAE,EAAE;;AAEzD,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yEAAyE;AAC3E;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACpE;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,mBAAmB,SAAW,EAAE,iBAAiB,EAAE;;AAEnD,qBAAqB,YAAY,EAAE,aAAa,EAAE;AAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;AAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;AAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;AAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;AAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;AAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;AAClD,qBAAqB,YAAY,EAAE,aAAa,EAAE;;AAElD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,0BAA0B,qBAAqB,EAAE;AACjD,kCAAkC,2BAA2B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAExG,mBAAmB,YAAY,EAAE;AACjC;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mFAAmF;EACnF,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;AAClB;AACA,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAEtF,cAAc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE;AAC3E,uBAAuB,aAAa,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC1E,sBAAsB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACzF,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAClF,qBAAqB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACpF,qBAAqB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACxG,sBAAsB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1F,qBAAqB,aAAa,EAAE,YAAY,EAAE,gBAAgB,EAAE;;AAEpE,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAO,EAAE;AAC1F,oBAAoB,eAAe,EAAE,kBAAkB,EAAE,WAAW,EAAE;;AAEtE,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,YAAY,EAAE;;AAEnF,sEAAsE;AACtE;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;AAClB;AACA,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACtF,qBAAqB,cAAc,EAAE,aAAa,EAAE,cAAc,EAAE;;AAEpE,mBAAmB,WAAW,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACjG;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;AACA,uCAAuC,kBAAkB,EAAE;AAC3D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAC3E,mBAAmB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACnF,iBAAiB,WAAW,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACzF,uBAAuB,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;;AAEtE;;;mEAGmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C,WAAW;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;AACA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;;AAExF;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,+BAA+B,0BAA0B,EAAE,mBAAmB,EAAE;;AAEhF;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA,OAAO;;AAEP;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,kCAAkC,WAAW,EAAE;;AAE/C;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,cAAc,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACvE;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;AACA,kCAAkC,kBAAkB,EAAE;AACtD,mCAAmC,WAAW,EAAE;AAChD;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;AAClC;AACA,kCAAkC,kBAAkB,EAAE;AACtD,qCAAqC,mBAAmB,EAAE;AAC1D,0CAA0C,mBAAmB,EAAE;AAC/D,gCAAgC,mBAAmB,EAAE;AACrD,8BAA8B,WAAW,EAAE;AAC3C,gCAAgC,cAAc,EAAE,gBAAgB,EAAE;AAClE,yBAAyB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,0BAA0B,EAAE;;AAExG;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;AACA,OAAO;AACP,wBAAwB,eAAe,GAAG,iBAAiB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC/F,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAChG,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACpE;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA,0CAA0C,WAAW,EAAE;AACvD,4CAA4C,cAAc,EAAE,mBAAmB,EAAE;AACjF,sCAAsC,cAAc,EAAE,0BAA0B,EAAE;AAClF,4CAA4C;AAC5C,wBAAwB,yBAAyB,EAAE,gBAAgB,EAAE;;AAErE,uCAAuC;AACvC,mBAAmB,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC7G,oBAAoB,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAChG;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB,gDAAgD,EAAE;EACpE;;sBAEoB,qCAAqC,EAAE;AAC7D;AACA;EACE,kBAAkB,qCAAqC,EAAE;EACzD,qBAAqB,WAAW,EAAE,8BAA8B,EAAE;EAClE,cAAc,sBAAsB,EAAE,uBAAuB,EAAE;EAC/D,uBAAuB,eAAe,EAAE;EACxC,qBAAqB,YAAY,EAAE;AACrC;;;AAGA,uBAAuB;AACvB;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;;EAElB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,WAAW;EACX,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,SAAS;AACT,WAAW;AACX;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,eAAe;;EAEf,mBAAmB;EACnB,cAAc;;EAEd,kBAAkB;EAClB,sBAAsB;;EAEtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;AACA,SAAS;AACT;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,2BAA2B;GAC1B,yCAAyC;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;;;AAGA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,oCAAoC;AACtC;;;AAGA;EACE,oCAAoC;AACtC","sourcesContent":["/* =====================================================================\r\n   dashboard.css  -  every class is prefixed with \"dash-\"\r\n   Replace the WHOLE old dashboard.css with this file.\r\n   ===================================================================== */\r\n\r\n/* ---------- page shell ---------- */\r\n.dash-page {\r\n  background: #fff;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  font-family: Inter, \"Poppins\", sans-serif;\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n.dash-page::-webkit-scrollbar { display: none; }\r\n\r\n.dash-page-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 0 0 16px 4px;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #111;\r\n}\r\n.dash-page-title img { width: 24px; height: 24px; }\r\n\r\n.dash-loader {\r\n  margin: 80px auto;\r\n  width: 46px;\r\n  height: 46px;\r\n  border: 5px solid #dbe6f5;\r\n  border-top-color: #2563b0;\r\n  border-radius: 50%;\r\n  animation: dash-spin 0.8s linear infinite;\r\n}\r\n@keyframes dash-spin { to { transform: rotate(360deg); } }\r\n\r\n/* ---------- filter bar ---------- */\r\n.dash-filter-bar {\r\n  position: relative;\r\n  z-index: 20;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 18px 28px;\r\n  padding: 22px 26px;\r\n  margin-bottom: 18px;\r\n  background: linear-gradient(90deg, #0b5cab 0%, #073c80 55%, #04295f 100%);\r\n}\r\n.dash-filter-group { display: flex; align-items: center; gap: 10px; }\r\n.dash-filter-label {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* 2/11 */\r\n.dash-filter-bar--center {\r\n  justify-content: space-around;\r\n}\r\n\r\n/* ---------- stat cards ---------- */\r\n.dash-card-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 18px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.dash-card {\r\n  --c: #2563b0;\r\n  --bg: #eef3fa;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  min-height: 138px;\r\n  padding: 16px 18px 18px;\r\n  border: 1.5px solid var(--c);\r\n  border-radius: 14px;\r\n  background: var(--bg);\r\n  box-sizing: border-box;\r\n}\r\n.dash-card--tall { flex: 1 1 0; min-height: 150px; }\r\n\r\n.dash-card--blue   { --c: #2563b0; --bg: #eef3fa; }\r\n.dash-card--purple { --c: #8e3fa8; --bg: #f6f0fa; }\r\n.dash-card--orange { --c: #e07a1a; --bg: #fdf7ee; }\r\n.dash-card--green  { --c: #22a05a; --bg: #eaf6ee; }\r\n.dash-card--pink   { --c: #c23a7c; --bg: #fbeaf1; }\r\n.dash-card--indigo { --c: #2b3a8f; --bg: #e8ebf9; }\r\n.dash-card--teal   { --c: #1a9e86; --bg: #e8faf8; }\r\n.dash-card--red    { --c: #c4243a; --bg: #fbe9eb; }\r\n\r\n.dash-card__icon img {\r\n  width: 36px;\r\n  height: 36px;\r\n  object-fit: contain;\r\n  border-radius: 50%;\r\n  display: block;\r\n}\r\n.dash-card__arrow {\r\n  position: absolute;\r\n  top: 14px;\r\n  right: 14px;\r\n  width: 22px;\r\n  height: 22px;\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--c);\r\n  font-size: 22px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.dash-card__arrow:hover { transform: scale(1.1); }\r\n.dash-card__arrow:focus-visible { outline: 2px solid var(--c); outline-offset: 2px; border-radius: 50%; }\r\n\r\n.dash-card__body { min-width: 0; }\r\n.dash-card__title {\r\n  margin: 0 0 4px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #3f4344;\r\n  line-height: 1.3;\r\n}\r\n.dash-card__value {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: var(--c);\r\n  white-space: nowrap;\r\n}\r\n.dash-card__bar {\r\n  height: 4px;\r\n  border-radius: 4px;\r\n  background: #c9cdd2;\r\n  overflow: hidden;\r\n}\r\n.dash-card__bar span {\r\n  display: block;\r\n  width: 75%;\r\n  height: 100%;\r\n  border-radius: 4px;\r\n  background: var(--c);\r\n}\r\n\r\n/* ---------- chart row ---------- */\r\n.dash-chart-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.65fr) minmax(250px, 0.9fr) minmax(220px, 0.65fr);\r\n  gap: 14px;\r\n  margin-bottom: 18px;\r\n  align-items: stretch;\r\n}\r\n.dash-chart-grid--budget {\r\n  grid-template-columns: minmax(0, 1.8fr) minmax(280px, 1fr);\r\n}\r\n\r\n.dash-chart-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  min-height: 340px;\r\n  padding: 20px;\r\n  background: #fff;\r\n  border-radius: 15px;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n.dash-chart-title { margin: 0 0 12px; font-size: 15px; font-weight: 700; color: #111; }\r\n\r\n.dash-spend { display: flex; align-items: center; gap: 10px; min-width: 0; }\r\n.dash-spend__summary { flex: 0 0 30%; min-width: 125px; max-width: 180px; }\r\n.dash-spend__amount { margin: 0; font-size: 34px; line-height: 1.1; white-space: nowrap; }\r\n.dash-spend__row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }\r\n.dash-spend__label { margin: 0; font-size: 13px; line-height: 1.3; color: darkgray; }\r\n.dash-spend__delta { margin: 0; font-size: 13px; font-weight: 700; color: #01b574; white-space: nowrap; }\r\n.dash-spend__status { margin: 8px 0 0; font-size: 15px; font-weight: 700; color: #01b574; }\r\n.dash-spend__chart { flex: 1 1 70%; min-width: 0; overflow: hidden; }\r\n\r\n.dash-taxes-chart { display: flex; align-items: center; justify-content: center; flex: 1; }\r\n.dash-empty-chart { padding: 40px 0; text-align: center; color: #999; }\r\n\r\n.dash-side-cards { display: flex; flex-direction: column; gap: 14px; min-width: 0; }\r\n\r\n/* ---------- bottom panels (Vendor Bills / Head Details) ---------- */\r\n.dash-bottom-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr);\r\n  gap: 14px;\r\n}\r\n.dash-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  height:auto;\r\n  padding: 18px 20px;\r\n  background: #fff;\r\n  border-radius: 15px;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n.dash-panel-title { margin: 0 0 14px; font-size: 14px; font-weight: 700; color: #111; }\r\n.dash-panel-scroll { flex: 1 1 auto; min-height: 0; overflow: auto; }\r\n\r\n.dash-mini-table { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 12px; }\r\n.dash-mini-table thead th {\r\n  padding: 9px 8px;\r\n  background: #2f78dc;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.45);\r\n}\r\n.dash-mini-table thead th:last-child { border-right: none; }\r\n.dash-mini-table tbody td {\r\n  padding: 9px 8px;\r\n  text-align: center;\r\n  color: #333;\r\n  border-bottom: 1px solid #eef1f6;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.dash-mini-table .dash-mini-empty {\r\n  padding: 16px;\r\n  background: #e6f2fb;\r\n  color: #333;\r\n  font-size: 12px;\r\n}\r\n.dash-status { display: flex; align-items: center; gap: 6px; min-width: 0; }\r\n.dash-status img { width: 16px; height: 16px; flex-shrink: 0; object-fit: contain; }\r\n.dash-mini-bar { height: 6px; background: #e3e7ee; border-radius: 6px; overflow: hidden; }\r\n.dash-mini-bar__fill { height: 100%; width: 50%; background: #2f78dc; }\r\n\r\n/* ---------- drill-down table page (grey shell + white card) ----------\r\n   measured from the reference screenshot:\r\n   shell padding 13/13/15/14 | header 36px, gap 12 | card padding 16/19\r\n   table head 41px, rows 43px | footer text 12px bold             */\r\n.dash-table-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 90vh;\r\n  padding: 13px 13px 15px 14px;\r\n  background: #edf0f5;\r\n  border-radius: 12px;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n  font-family: Arial, Helvetica, sans-serif;\r\nmargin:25px;\r\n}\r\n.dash-table-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  height: 37px;\r\n  margin-bottom: 12px;\r\n}\r\n.dash-table-head__left { display: flex; align-items: center; gap: 14px; flex-shrink: 0; }\r\n\r\n.dash-back-btn {\r\n  width: 36px;\r\n  height: 37px;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n.dash-back-btn__icon {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 6px;\r\n  background: #0b4f99;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.dash-back-btn:focus-visible { outline: 2px solid #2684ff; outline-offset: 2px; }\r\n\r\n.dash-table-title {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #000;\r\n  white-space: nowrap;\r\n}\r\n\r\n/*2/11*/\r\n\r\n.dash-search {\r\n  position: relative;\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.dash-search-icon {\r\n  position: absolute;\r\n  left: 14px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 16px;\r\n  height: 16px;\r\n  padding: 0;                    \r\n  background: transparent;\r\n  border-radius: 0;\r\n  object-fit: contain;\r\n  pointer-events: none;\r\n}\r\n\r\n.dash-search-input {\r\n  width: 222px;\r\n  height: 34px;\r\n  padding: 0 12px 0 38px;\r\n  border: 1px solid #dfe6ee;\r\n  border-radius: 5px;  \r\n  background: #fff;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  color: #111;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dash-search-input::placeholder { color: #777; }\r\n\r\n.dash-search-input:focus {\r\n  border-color: #2684ff;\r\n  box-shadow: 0 0 0 1px #2684ff;\r\n}\r\n.dash-table-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  padding: 16px 19px ;\r\n  background: #fff;\r\n  border-radius: 14px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n}\r\n.dash-table-scroll {\r\n  flex: 0 1 auto;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  border-radius: 4px;\r\n  position: relative;\r\n}\r\n\r\n.dash-table { width: 100%; border-collapse: collapse; font-size: 12px; }\r\n.dash-table thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n  height: 41px;\r\n  padding: 0 12px;\r\n  background: #2f7bda;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  border-right: 1px solid #8db8ee;\r\n}\r\n.dash-table thead th:last-child { border-right: none; }\r\n.dash-table thead th:first-child { width: 60px; }\r\n.dash-table tbody td {\r\n  height: 43px;\r\n  padding: 0 12px;\r\n  background: #e4f1fb;\r\n  color: #000;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  border-right: 1px solid #f3f9fe;\r\n  border-bottom: 1px solid #cfe3f6;\r\n}\r\n.dash-table tbody td:last-child { border-right: none; }\r\n.dash-table tbody tr:last-child td { border-bottom: none; }\r\n.dash-table tbody tr:nth-child(even) td { background: #edf6fd; }\r\n.dash-table tbody tr:hover td { background: #d9ebfa; }\r\n.dash-table .dash-cell-link { color: blue; }\r\n.dash-table .dash-cell-amount { color: #2f78dc; font-weight: 700; }\r\n.dash-table .dash-link { color: #2f78dc; font-weight: 700; cursor: pointer; text-decoration: underline; }\r\n\r\n.dash-empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 43px;\r\n  background: #e4f1fb;\r\n  color: #000;\r\n  font-size: 12px;\r\n}\r\n\r\n.dash-view-btn {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5);\r\n  color: #fff;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ---------- pagination (table pages) ---------- */\r\n.dash-pagination {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 16px 0 20px;\r\n}\r\n/*2/11*/\r\n.dash-pagination-info { font-size: 12px;  line-height: 14px; color: #000; white-space: nowrap; }\r\n.dash-pagination-controls { display: flex; align-items: center; gap: 22px; white-space: nowrap; }\r\n.dash-page-numbers { display: flex; align-items: center; gap: 14px; }\r\n.dash-pagination-controls button {\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  color: #444;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  line-height: 14px;\r\n  cursor: pointer;\r\n}\r\n.dash-pagination-controls .dash-nav-btn { color: #555; }\r\n.dash-pagination-controls button:disabled { color: #b3b3b3; cursor: not-allowed; }\r\n.dash-page-numbers button.is-active { color: #2ea4e7; text-decoration: underline; }\r\n/* small pager inside the dashboard panels */\r\n.dash-pagination--end { justify-content: flex-end; padding: 8px 0 0; }\r\n\r\n/* ---------- photo viewer ---------- */\r\n.dash-photo-page { height: 89vh; padding: 20px 24px; background: #fff; overflow-x: hidden; overflow-y: auto; }\r\n.dash-photo-title { margin-bottom: 24px; font-size: 20px; font-weight: 700; text-align: center; }\r\n.dash-photo-lightbox {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 99999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background: rgba(0, 0, 0, 0.85);\r\n}\r\n\r\n/* ---------- responsive ---------- */\r\n@media (max-width: 1200px) {\r\n  .dash-card-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .dash-chart-grid,\r\n  .dash-chart-grid--budget,\r\n  .dash-bottom-grid { grid-template-columns: minmax(0, 1fr); }\r\n}\r\n@media (max-width: 640px) {\r\n  .dash-card-grid { grid-template-columns: minmax(0, 1fr); }\r\n  .dash-filter-group { width: 100%; justify-content: space-between; }\r\n  .dash-spend { flex-direction: column; align-items: flex-start; }\r\n  .dash-spend__summary { max-width: none; }\r\n  .dash-search-input { width: 170px; }\r\n}\r\n\r\n\r\n/* Table outer border */\r\n.dash-table-scroll {\r\n  flex: 0 1 auto;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  border-radius: 5px;\r\n  position: relative;\r\n\r\n  /* Remove gaps between cells */\r\n  padding: 0;\r\n}\r\n\r\n/* Main table */\r\n.dash-table {\r\n  width: 100%;\r\n  border-collapse: collapse !important;\r\n  border-spacing: 0 !important;\r\n  table-layout: auto;\r\n  font-size: 12px;\r\n}\r\n\r\n/* 2/11 */\r\n/* Header */\r\n.dash-table-scroll {\r\n  flex: 0 1 auto;\r\n  min-height: 0;\r\n  overflow: auto; \r\n  border-radius: 5px;\r\n  position: relative;\r\n  padding: 0;\r\n}\r\n/* Header first and last cells */\r\n.dash-table thead th:first-child {\r\n  width: 60px;\r\n  border-left: none;\r\n}\r\n\r\n.dash-table thead th:last-child {\r\n  border-right: none;\r\n}\r\n\r\n/* Table body cells */\r\n.dash-table tbody td {\r\n  height: 43px;\r\n  padding: 0 12px;\r\n\r\n  background: #e4f1fb;\r\n  color: #000000;\r\n\r\n  text-align: center;\r\n  vertical-align: middle;\r\n\r\n  /* Same continuous borders */\r\n  border: 1px solid #cfe3f6;\r\n}\r\n\r\n/* Remove outer cell borders */\r\n.dash-table tbody td:first-child {\r\n  border-left: none;\r\n}\r\n\r\n.dash-table tbody td:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.dash-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Alternate rows */\r\n.dash-table tbody tr:nth-child(even) td {\r\n  background: #edf6fd;\r\n}\r\n\r\n/* Hover */\r\n.dash-table tbody tr:hover td {\r\n  background: #d9ebfa;\r\n}\r\n/* 2/11 */\r\n.dash-table-card .dash-table-scroll {\r\n  padding: 0 !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-table {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  border: 0 !important;\r\n  border-collapse: separate !important; \r\n  border-spacing: 0 !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-table thead,\r\n.dash-table-card .dash-table-scroll .dash-table thead tr {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  border: 0 !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-table thead th {\r\n  margin: 0 !important;\r\n  background: #2f7bda !important;\r\n  border-top: 0 !important;\r\n  border-bottom: 0 !important;\r\n  border-left: 0 !important;\r\n  border-right: 1px solid #ffffff !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-table thead th:last-child {\r\n  border-right: 0 !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-table tbody td {\r\n  border: 0 !important;\r\n  border-right: 1px solid white !important;\r\n  border-bottom: 1px solid white !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-table tbody td:last-child {\r\n  border-right: 0 !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-table tbody tr:last-child td {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\n.dash-table-card .dash-table-scroll .dash-empty {\r\n  margin: 0 !important;\r\n}\r\n\r\n/* 2/11 */\r\n.dash-panel .dash-panel-scroll {\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.dash-panel .dash-mini-table {\r\n  margin: 0 !important;\r\n  border: 0 !important;\r\n  border-collapse: separate !important;\r\n  border-spacing: 0 !important;\r\n}\r\n\r\n.dash-panel .dash-mini-table thead,\r\n.dash-panel .dash-mini-table thead tr {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  border: 0 !important;\r\n}\r\n\r\n.dash-panel .dash-mini-table thead th {\r\n  margin: 0 !important;\r\n  background: #2f78dc !important;\r\n  color: #fff !important;\r\n  border: 0 !important;\r\n  border-right: 1px solid white !important;\r\n  box-shadow: none !important;\r\n   border-bottom: 1px solid white !important;\r\n}\r\n\r\n.dash-panel .dash-mini-table thead th:last-child {\r\n  border-right: 0 !important;\r\n}\r\n\r\n.dash-panel .dash-mini-table tbody td {\r\n  border: 0 !important;\r\n  border-bottom: 1px solid white !important;\r\n}\r\n\r\n\r\n.dash-panel .dash-panel-title {\r\n  margin: 0 0 8px !important;\r\n}\r\n\r\n\r\ntable tbody tr:nth-child(odd) td {\r\n  background-color: #E5F4FB !important;\r\n}\r\n\r\n\r\ntable tbody tr:nth-child(even) td {\r\n  background-color: #CEE4F1 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
